const omopControlApi = {
  listPageForm: '/kbms/omop/standard/listPageForm', // 分页查询表单
  listPageField: '/kbms/omop/standard/listPageField', // 分页查询字段
  saveField: '/kbms/omop/standard/saveField', // 保存字段
  saveForm: '/kbms/omop/standard/saveForm', // 保存表单
}

export default omopControlApi
